
import { Hidden, Tabs, Tab } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const NavTabs = () => {

    const [state, setState] = useState<number>();
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        let tabState: number;
        switch (location.pathname.split('/')[1].toLowerCase()) {
            case '':
                tabState = 1
                break;
            case 'campaigns':
                tabState = 2;
                break;
            case 'missions':
                tabState = 3;
                break;
            default:
                tabState = 1;
        }
        setState(tabState)

    }, [location])

    const tabsHandler = (value: number) => {
        if (state !== value) {
            switch (value) {
                case 1:
                    history.push('/');
                    break;
                case 2:
                    history.push('/Campaigns');
                    break;
                case 3:
                    history.push('/Missions');
                    break;
            }
        }
    }

	return (
        <Hidden only={['xs']}>
            <Tabs
                onChange={(evt, value) => {
                    tabsHandler(value)
                }}
                aria-label="navigation tabs"
                value={state}
            >
                <Tab label="Home" value={1} />
                <Tab label="Campaigns" value={2} />
                <Tab label="Missions" value={3} />
            </Tabs>
        </Hidden>
	)
}
export default NavTabs ;
